import {Injectable} from '@angular/core';

@Injectable({
              providedIn: 'root'
            })
export class ManagedLocaleService {

  public static DEFAULT_LOCALE_FR = 'fr';
  public static LOCALE_EN = 'en';
  public static LOCALE_DE = 'de';
  public static LOCALE_IT = 'it';
  public static LOCALE_ES = 'es';
  public static LOCALE_NL = 'nl';

  public static MANAGED_LOCALES = [ManagedLocaleService.DEFAULT_LOCALE_FR,
                                   ManagedLocaleService.LOCALE_EN,
                                   ManagedLocaleService.LOCALE_DE,
                                   ManagedLocaleService.LOCALE_IT,
                                   ManagedLocaleService.LOCALE_ES,
                                   ManagedLocaleService.LOCALE_NL];

  public static getSimplifiedLocaleOrFrByDefault(locale: string): string {
    const foundLanguage = ManagedLocaleService.MANAGED_LOCALES.filter(managedLanguage => locale.startsWith(managedLanguage))[0];
    if (foundLanguage) {
      return foundLanguage;
    } else {
      return ManagedLocaleService.DEFAULT_LOCALE_FR;
    }
  }
}
